import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import myConnections from "../../utility/connect";


const sliceName = "systemSlice";

const defaultTheme = "mainTheme";

const initialState = {
  lang: null,
  initialLangLoaded: false,
  theme: null,
  initialThemeLoaded: false,
  OS: null,
  settings: {
    req_permission1: null,
    req_permission2: null,
    req_permission3: null,
    req_permission4: null,
    currency: null,
  },
  systemSettingsBucket: [],
  systemSettingsFetchStarted: false,
};

let getSystemSettings = async (_, thunkAPI) => {
  const response = await myConnections.get({
    path: "sifrarnici/get_settings",
    data: {},
    headers: {},
    thunkAPI: thunkAPI,
  });

  return response;
};

getSystemSettings = createAsyncThunk(
  `${sliceName}/getSystemSettings`,
  getSystemSettings
);
getSystemSettings.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, action) => {
    const result = action.payload.items[0];


    state.settings = {
      ...result,
      req_permission1: result.req_permission1 === "Y",
      req_permission2: result.req_permission2 === "Y",
      req_permission3: result.req_permission3 === "Y",
      req_permission4: result.req_permission4 === "Y",
      init_value_permission1: result.init_value_permission1 === "Y",
      init_value_permission2: result.init_value_permission2 === "Y",
      init_value_permission3: result.init_value_permission3 === "Y",
      init_value_permission4: result.init_value_permission4 === "Y",
      req_town_city: result.req_town_city === "Y",
      fk_town_city: result.fk_town_city === "Y",
      hide_channels_code: result.hide_channels_code === "Y",
    };

    const randomBanner = state.settings.banners.length > 0 ? state.settings.banners[Math.floor(Math.random() * state.settings.banners.length)] : null;
    state.settings.randomBanner = randomBanner;

  },
  rejected: (state, action) => {},
};

///////////////////////////////////////////////////////////////////////THEME

const setSystemTheme = (state, action) => {
  let theme = action.payload?.theme ?? defaultTheme;
  state.theme = theme;
  state.initialThemeLoaded = true;
};

///////////////////////////////////////////////////////////////////////LANG

const setSystemLanguage = (state, action) => {
  state.lang = action.payload.lang;
  state.initialLangLoaded = true;

  state.initialLangLoaded = true;
};

const setSystemOS = (state, action) => {
  state.OS = action.payload.OS;
};

////////////////////////////////////////////////////////////////////////////////////////////

let processId = 0;
const addToSystemSettingsBucket = (state, action) => {
  processId++;
  const prevstate = [...state.systemSettingsBucket];
  prevstate.push({
    processId: processId,
    processName: action.payload?.processName,
  });
  state.systemSettingsBucket = prevstate;
  action.payload = { ...action.payload, processId: processId };
};

const removeFromSettingsBucket = (state, action) => {
  const prevstate = [...state.systemSettingsBucket];
  const newState = prevstate.filter(
    (element) => element.processId !== action.payload.processId
  );
  state.systemSettingsBucket = newState;
};

const setSystemSettingsFetchStartedToTrue = (state, action) => {
  state.systemSettingsFetchStarted = true;
};

const systemSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {
    setSystemLanguage,
    setSystemTheme,
    setSystemOS,
    addToSystemSettingsBucket,
    removeFromSettingsBucket,
    setSystemSettingsFetchStartedToTrue,
  },
  extraReducers: (builder) => {
    builder.addCase(getSystemSettings.pending, getSystemSettings.myLC.pending);
    builder.addCase(
      getSystemSettings.fulfilled,
      getSystemSettings.myLC.fulfilled
    );
    builder.addCase(
      getSystemSettings.rejected,
      getSystemSettings.myLC.rejected
    );
  },
});

export const asyncActions = {
  getSystemSettings,
};
export const actions = systemSlice.actions;
export default systemSlice.reducer;
